'use client'

import Script from 'next/script'
import { useEffect, useState } from 'react'

const WEBSITE_ID = 'ba656d45-8914-4b22-a4f4-2bfd39fd73fc'

// Routes whose URL (or screen) carries secrets such as tokens or one-time codes.
const SENSITIVE_ROUTES = [
  '/handshake',
  '/primeiro-acesso',
  '/acesso',
  '/reset-password',
  '/resetar-senha',
  '/recuperar-senha',
  '/trocar-senha',
  '/verificar-dispositivo',
]

function isSensitivePath(pathname: string): boolean {
  return SENSITIVE_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`))
}

/**
 * Loads the Jorney session recorder, except when the page was first opened on a
 * route that carries secrets. The decision is made once, from the initial pathname.
 */
export function JorneyRecorder() {
  const [allowed, setAllowed] = useState(false)

  useEffect(() => {
    setAllowed(!isSensitivePath(window.location.pathname))
  }, [])

  if (!allowed) return null

  return (
    <Script
      src="https://jorney.mentorfy.io/recorder.js"
      strategy="afterInteractive"
      data-website-id={WEBSITE_ID}
    />
  )
}
